
export const baseUriModel = "http://www.example.org/buildingmodel#//" as const;

export const representationUriModel = `${baseUriModel}resources/representations/` as const;
export const geometryUriModel = `${representationUriModel}geometries/` as const;

export const locationUriModel = `${baseUriModel}resources/locations/` as const;

export const structuralUriModel = `${baseUriModel}structural/` as const;
